<template>
    <Sheet>  <h2>{{routeTitle}}</h2>


             <el-form :model="model"
                      :rules="rules"
                      label-width="150px"
                      ref="form">
                 <el-form-item label="身份證字號"
                               prop="iDno">
                     <el-input placeholder="請輸入身份證字號"
                               v-model="model.iDno"></el-input>
                 </el-form-item>
                 <el-form-item label="姓名"
                               prop="name">
                     <el-input placeholder="請輸入姓名"
                               v-model="model.name"></el-input>
                 </el-form-item>
                 <el-form-item label="部別"
                               prop="divisName">
                     <el-input placeholder="請輸入部別"
                               v-model="model.divisName"></el-input>
                 </el-form-item>
                 <el-form-item label="學號"
                               prop="studentId">
                     <el-input placeholder="請輸入學號"
                               v-model="model.studentId"></el-input>
                 </el-form-item>
                 <el-form-item label="系所"
                               prop="departmentName">
                     <el-input placeholder="請輸入系所"
                               v-model="model.departmentName"></el-input>
                 </el-form-item>
                 <el-form-item label="班級"
                               prop="className">
                     <el-input placeholder="請輸入班級"
                               v-model="model.className"></el-input>
                 </el-form-item>
                 <el-form-item label="電子郵件"
                               prop="email">
                     <el-input placeholder="請輸入電子郵件"
                               v-model="model.email"></el-input>
                 </el-form-item>
                 <el-form-item label="行動電話"
                               prop="mobiphone">
                     <el-input placeholder="請輸入行動電話"
                               v-model="model.mobiphone"></el-input>
                 </el-form-item>
                 <el-form-item label="戶籍地址"
                               prop="domicile">
                     <el-input placeholder="請輸入戶籍地址"
                               v-model="model.domicile"></el-input>
                 </el-form-item>
                 <el-form-item label="測驗類別"
                               prop="category">
                     <el-select v-model="model.category" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in categoryitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item label="前測類別"
                               prop="pre_kind">
                               <el-radio-group v-model="model.pre_kind" >
                               <el-radio
                                    v-for="item in prekinditem"
                                    :key="'n' + item.no"
                                    :label="item.codeName">
                                    {{ item.codeName }}
                                </el-radio>
                                </el-radio-group>
                 </el-form-item>
                 <el-form-item label="前測成績"
                               prop="pre_test">
                     <el-input placeholder="請輸入前測成績"
                               v-model="model.pre_test"></el-input>
                 </el-form-item>
                 <el-form-item :label="'前測日期'"
                               prop="pre_date">
                               <el-date-picker
                                placeholder="請輸入前測日期"
                                type="date"
                                v-model="model.pre_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                  <el-form-item label="後測類別"
                               prop="post_kind">
                               <el-radio-group v-model="model.post_kind">
                               <el-radio
                                    v-for="item in postkinditem"
                                    :key="'n' + item.no"
                                    :label="item.codeName">
                                    {{ item.codeName }}
                                </el-radio>
                                </el-radio-group>
                 </el-form-item>
                 <el-form-item label="後測成績"
                               prop="post_test">
                     <el-input placeholder="請輸入後測成績"
                               v-model="model.post_test"></el-input>
                 </el-form-item>
                  <el-form-item :label="'後測日期'"
                               prop="post_date">
                               <el-date-picker
                                placeholder="請輸入後測日期"
                                type="date"
                                v-model="model.post_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                 <el-form-item label="銀行名稱/銀行分行"
                               prop="bankname">
                     <el-input placeholder="請輸入銀行名稱/銀行分行"
                               v-model="model.bankname"></el-input>
                 </el-form-item>
                 <el-form-item label="銀行帳號"
                               prop="bankno">
                     <el-input placeholder="請輸入銀行帳號"
                               v-model="model.bankno"></el-input>
                 </el-form-item>
                 <el-form-item label="曾修習本校英語課程"
                               prop="iS_studyEnglish">
                     <el-radio-group v-model="model.iS_studyEnglish">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                     <span style="color:red;">
                         注意：若選「否」則不能申請
                     </span>
                 </el-form-item>
                 <el-form-item label="課程名稱"
                               prop="course">
                     <el-input placeholder="請輸入課程名稱"
                               v-model="model.course"></el-input>
                 </el-form-item>
                 <el-form-item label="等級"
                               prop="grade">
                     <el-select v-model="model.grade" placeholder="請選擇" tabindex="2" @change="money()">
                         <el-option v-for="item in gradeitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                     <a href="https://scholarshipweb.ncut.edu.tw/English.jpg" target="_blank">英文進步獎勵級距表</a>
                 </el-form-item>

                 <el-form-item label="申請金額"
                               prop="application_money">
                     <el-input placeholder="申請金額"
                               v-model="model.application_money" :disabled="true"></el-input>
                 </el-form-item>

                 <el-form-item label="申請報名費"
                               prop="iS_app_reg_fee"
                               v-if="model.fee_flag">
                     <el-radio-group v-model="model.iS_app_reg_fee"
                                     v-if="model.fee_flag">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos"
                                   v-if="model.fee_flag">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                     <span style="color:red;">
                        「每人限申請一次」
                     </span>
                 </el-form-item>
                 <el-form-item label="報名費金額"
                               prop="registery_fee"
                               v-if="model.fee_flag">
                     <el-input placeholder="報名費金額"
                               v-model="model.registery_fee"
                               v-if="model.fee_flag" :disabled="model.iS_app_reg_fee==='否'"></el-input>
                 </el-form-item>
                 <!--<el-form-item label="是否審核"
                  prop="isReview">
        <el-radio-group v-model="model.isReview">
            <el-radio :label="e.value"
                      v-for="e in yesnos">
                {{e.label}}
            </el-radio>
        </el-radio-group>
    </el-form-item>
    <el-form-item label="核定金額"
                  prop="approved_amount">
        <el-input placeholder="核定金額"
                  v-model="model.approved_amount"></el-input>
    </el-form-item>
    <el-form-item label="核定內容"
                  prop="review_content">
        <el-input placeholder="核定內容"
                  v-model="model.review_content"></el-input>
    </el-form-item>-->
                 <el-form-item label="檢附資料(檢附文件若不完備，將不予受理)" v-if="fileLimit">

                     <el-upload :action="action"
                                :before-remove="handleBeforeRemove"
                                :before-upload="beforeUpload"
                                :data="dataOptions"
                                :headers="uploadHeaders"
                                :limit="4"
                                :on-error="onUploadError"
                                :on-exceed="onExceedLimit"
                                :on-success="onUploadSuccess"
                                ref="upload">
                         <el-button>選擇檔案</el-button>
                         <template #tip>
                             <div class="el-upload__tip" style="font-size:large; font-weight:bold;color:red;">
                                 檔案不超過5MB，限以jpg或pdf格式上傳。
                             </div>
                         </template>
                     </el-upload>
                     <span style="color:red;">
                         檢附資料：<br />
                         1、2次檢定考試成績單影本或檢定合格證書/等級證明<br />
                         2、檢定考試報名費收據影本(無則免附)<br />
                         3、學生證正面影本<br />
                         4、申請人本人銀行/郵局存封面影本一張<br />
                         (獎助補助款將由學校直接匯入申請人提供之銀行帳戶)
                     </span>
                 </el-form-item>
                 <el-button @click="submit"  :disabled="model.iS_studyEnglish==='否'">
                     送件
                 </el-button>
             </el-form>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import moment from 'moment';
    import routeTitleMixin from './routeTitleMixin';
    import UploadMixin from '../uploadMixin';

    const defaultModel = {
        idno:'',
        name: '',
        divisName:'',
        studentId:'',
        departmentName:'',
        className:'',
        email: '',
        mobile: '',
        domicile:'',
        category:'',
        pre_kind: null,
        post_kind: null,
        pre_test:'0',
        post_test:'0',
        bankname:'',
        bankno:'',
        iS_studyEnglish:null,
        course:'',
        grade:'',
        application_money:'0',
        iS_app_reg_fee:null,
        registery_fee:'0',
        isReview:null,
        approved_amount:'0',
        review_content:'',
        fee_flag: true,
        uploads: [],
    };

    export default {
        name: 'Form',
        data: () => ({
           categoryitem:null,
           gradeitem:null,
           prekinditem:null,
           postkindtemp:null,
           model: {...defaultModel},

            rules: {
                name: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'}
                ],
               category: [
                    {required: true, message: '請選擇測驗類別', trigger: 'blur'}
                ],
                 post_test: [
                    {required: true, message: '請輸入後測成績', trigger: 'blur'}
                ],
                post_date: [
                    {required: true, message: '請輸入後測日期', trigger: 'blur'}
                ],
                course: [
                    {required: true, message: '請輸入課程名稱', trigger: 'blur'}
                ],
                bankname: [
                    {required: true, message: '請輸入銀行名稱/銀行分行', trigger: 'blur'}
                ],
               bankno: [
                    {required: true, message: '請輸入請輸入銀行帳號', trigger: 'blur'}
                ],
              iS_studyEnglish: [
                    {required: true, message: '請選擇是否曾修習本校英語課程', trigger: 'blur'}
                ],
             grade: [
                    {required: true, message: '請選擇等級', trigger: 'blur'}
                ],
            application_money: [
                    {required: true, message: '請輸入請輸入申請金額', trigger: 'blur'}
                ],
            iS_app_reg_fee: [
                    {required: true, message: '請選擇是否申請報名費', trigger: 'blur'}
                ],
            },
            url: 'upload',
        }),

        computed: {
            ...mapState('englishform', ['forms', 'selectedForm']),
            ...mapState('codeDt', ['codeList']),

             yesnos() {
                return [
                    {label: '是', value: '是'},
                    {label: '否', value: '否'},
                ];
            },

        },

        mixins: [routeTitleMixin, UploadMixin],

        methods: {
            ...mapActions('englishform', {
                insert: 'insertFormAction',
                get: 'getstudFormsAction'
            }),
            ...mapActions('codeDt', {
                getCode: 'getCodeNo',
            }),
            money: function() {

                          if (this.model.grade == "1級–新台幣壹仟元整"){
                                     this.model.application_money=1000;
                              }
                           else if (this.model.grade == "2級–新台幣壹仟貳佰元整")
                           {
                                  this.model.application_money=1200;
                           }
                          else if (this.model.grade == "3級–新台幣壹仟伍佰元整")
                          {
                                  this.model.application_money=1500;
                          }
                          else if (this.model.grade == "4級–新台幣壹仟捌佰元整")
                          {
                                 this.model.application_money=1800;
                          }
                          else if (this.model.grade == "5級–新台幣貳仟貳佰元整")
                          {
                                  this.model.application_money=2200;
                          }
                          else if (this.model.grade == "6級–新台幣貳仟陸佰元整")
                          {
                                  this.model.application_money=2600;
                          }
                          else if (this.model.grade == "7級–新台幣叁仟壹佰元整")
                          {
                                  this.model.application_money=3100;
                          }
                   },
            submit() {
                if (this.model.iS_app_reg_fee === '否') {
                   this.model.registery_fee = 0;
                  }
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {

                        const {success} = await this.insert({
                            ...this.model
                        });
                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '表單送出成功'
                            });
                            this.$router.push('/StuenglishTable')
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '表單送出失敗，請重試一次'
                            });
                        }
                        this.reset();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                })
            },

            reset() {
                const vm = this;
                this.$refs['form'].resetFields();
                this.$nextTick(() => vm.$refs['form'].clearValidate());
                this.model = {...defaultModel};
                this.$refs['upload'].clearFiles();
            },

            onUploadSuccess(res) {
                this.model.uploads.push(res);
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.model.uploads = this.model.uploads.filter(f => f.uid !== file.uid);
            }
        },

        watch: {

            selectedForm(current) {
               this.model = {
                 ...defaultModel,
                 ...current
                };
 
             if (!this.model.pre_kind) {
                  this.model.pre_kind = null;
               }
               if (!this.model.post_kind) {
                  this.model.post_kind = null;
               }
            },

           'model.iS_app_reg_fee'(val) {
             if (val === '否') {
              this.model.registery_fee = 0;
             }
           }
        },

        async created() {
           var success = await this.getCode(2);

            if (success) {
                         this.categoryitem=success;}

         var  gradetemp = await this.getCode(3);
    if (gradetemp) {
                         this.gradeitem=gradetemp;}
         var  prekindtemp = await this.getCode(14);
    if (prekindtemp) {
                         this.prekinditem=prekindtemp;}
          var  postkindtemp = await this.getCode(15);
    if (postkindtemp) {
                         this.postkinditem=postkindtemp;}               
            this.get();
        }

    }</script>

<style scoped>

</style>